<script>
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Common from '../../../common/Common.vue'
import Services from '../../../common/Services.vue'
import { applySessionScope } from '../../../utils/scope'

export default {
    init: async payload => {
        payload.isSuperAdminMaster = await Common.isSuperAdminMaster(payload)

        const role = await Common.getSubtype(payload)
        payload.role = role

        await payload.initTable()
        const account = Common.getAccountId(payload)
        const needsSites = role === 'MANAGER' || role === 'OPERATOR' || role === 'AUDITOR'
        payload.filters.account = account
        if (needsSites) payload.filters.client = Common.getClientId(payload)
        if (!payload.isSuperAdminMaster) payload.columns.splice(3, 1)
        if (role === 'AUDITOR') payload.columns.splice(3, 1)
        payload.filter()

        await Promise.all([
            Services.getAccounts(payload).then(accounts => { payload.accounts = accounts }),
            account ? Services.getClients(payload).then(clients => { payload.clients = clients }) : Promise.resolve(),
            needsSites ? Services.getSites(payload).then(sites => { payload.sites = sites }) : Promise.resolve(),
        ])
    },
    methods: {
        filter: function () {
            const requestId = this.userListRequestId = (this.userListRequestId || 0) + 1
            if (!applySessionScope(this, this.filters)) {
                this.items = []
                this.totalItems = 0
                this.isLoading = false
                this.loadError = true
                return
            }

            this.isLoading = true
            this.loadError = false
            this.items = []
            this.enrichFiltersWithPagination()
            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                { ...this.filters },
                `${Endpoints.systemUsers.customerUser.search}`,
                response => {
                    if (requestId !== this.userListRequestId) return
                    if (!Array.isArray(response?.results) || (response.status && response.status !== 200)) {
                        this.loadError = true
                        this.isLoading = false
                        return
                    }
                    this.applyServerPage(response)
                    this.isLoading = false
                },
                () => {
                    if (requestId !== this.userListRequestId) return
                    this.loadError = true
                    this.isLoading = false
                },
            )
        },
        selectItem(params) {
            if (this.role === 'AUDITOR') return
            const data = params && params?.row ? JSON.parse(JSON.stringify(params.row)) : { ...this.vigilantObj }

            delete data.vgt_id
            delete data.originalIndex
            delete data.password

            data.account = data?.account?._id || ''
            data.client = data?.client?._id || ''
            data.site = data?.site?._id || ''

            if (!data?.address?._id) {
                data.address = {}
            }

            this.data = data

            this.$bvModal.show('createGuardModal')
        },

        async initTable() {
            this.columns = [
                {
                    label: this.$t('str.table.user.column.name'),
                    field: 'fullName',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.user.column.customer.employee.code'),
                    field: 'customerUser.employeeCode',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.user.column.customer.type'),
                    field: 'customerUser.subtype',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.user.column.account'),
                    field: 'account.name',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
              
                {
                    label: this.$t('str.table.user.column.client'),
                    field: 'client.name',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.user.column.site'),
                    field: 'site.name',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.user.column.email'),
                    field: 'email',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.user.column.phone'),
                    field: 'primaryPhone',
                    type: 'phone',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.user.column.creat.at'),
                    field: 'createDate',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.user.column.status'),
                    field: 'status',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
            ]
            this.paginationOptions = this.buildServerPaginationOptions(this)
        },
        changeAccount: async function () {
            const account = this.filters.account

            this.sites = []
            this.filters.client = ''
            this.filters.site = ''

            this.filterFromFirstPage()

            this.clients = await Services.getClientsByAccount(this, account)
        },
        changeClient: async function () {
            const client = this.filters.client

            if (client === '') {
                this.filters.site = ''
            }

            this.filterFromFirstPage()

            this.sites = await Services.getSitesByClient(this, client)
        },
        changeSite: function () {
            this.filterFromFirstPage()
        },
        formatDate: Common.formatDateAndTime,
    },
}
</script>
